import { produce } from "immer";
import {
  TOGGLE_FOLDER_ADD_MODAL,
  TOGGLE_FILE_INFO_MODAL,
  TOGGLE_FOLDER_UPLOAD_MODAL,
  TOGGLE_DELETE,
  TOGGLE_FILE_VALID_MODAL,
  TOGGLE_STEP_DELETE,
  TOGGLE_FIELD_DELETE,
  TOGGLE_CONFIRM_MODAL,
  TOGGLE_HISTORY_MODAL,
  TOGGLE_ASSESSMENT_TOOL_MODAL,
  TOGGLE_BODY_MAP_MODAL,
  TOGGLE_BODY_MAP_OVERVIEW_MODAL,
  TOGGLE_TOOLSNAPSHOT_MODAL,
  TOGGLE_VERSION_REVIEW_MODAL,
  TOGGLE_WARNING_MODAL,
  TOGGLE_PRE_STATUS_MODAL,
  TOGGLE_CONVERT_RESIDENT_MODAL,
  TOGGLE_RESIDENT_STATUS_MODAL,
  TOGGLE_RESIDENT_SCHEDULE_MODAL,
  TOGGLE_RESIDENT_MEDICATION_MODAL,
  TOGGLE_DRAFT_CONFIRMATION_MODAL,
  TOGGLE_RESIDENT_APPOINTMENT_MODAL,
  TOGGLE_RESIDENT_GOVERNANCE_MODAL,
  TOGGLE_BODY_MAP_PREVIEW_MODAL,
  TOGGLE_TOOL_PREVIEW_MODAL,
  TOGGLE_OBSERVATION_MODAL,
  TOGGLE_OBSERVATION_FORM_MODAL,
  TOGGLE_BODY_MAP_ENTRY_MODAL,
  TOGGLE_PRE_ASSESSMENT_DOC_MODAL,
  TOGGLE_RESIDENT_DOCUMENT_MODAL,
  TOGGLE_RESIDENT_DOCUMENT_VIEW_MODAL,
  TOGGLE_REVISION_VIEW_MODAL,
  TOGGLE_PUBLISH_CONFIRMATION_MODAL,
  TOGGLE_SNOOZE_MODAL,
  TOGGLE_EVIDENCE_MODAL,
  TOGGLE_GOVERNANCE_STATUS_MODAL,
  TOGGLE_ASSIGN_MODAL,
  TOGGLE_EVALUATION_MODAL,
  TOGGLE_CARE_PLAN_EVALUATION_MODAL,
  TOGGLE_CARE_PLAN_STATUS_MODAL,
  TOGGLE_COMPLETE_MODAL,
  TOGGLE_MONITOR_MODAL,
  TOGGLE_MAINTENANCE_COMPLIANCE_ADD_MODAL,
  TOGGLE_MAINTENANCE_INVOICE_ADD_MODAL,
  TOGGLE_POLICY_ACKNOWLEDGEMENT_REPORT_MODAL,
  TOGGLE_CARE_ROUND_REPORT_MODAL,
  TOGGLE_REGISTER_MODAL,
  TOGGLE_WORKSPACE_MODAL,
} from "./constants";

export const initialState = {
  isFolderAddModalOpen: {
    open: false,
  },
  isFileInfoModalOpen: {
    open: false,
  },
  isUploadModalOpen: {
    open: false,
  },
  isDeleteModalOpen: {
    open: false,
  },
  isFileValidationModalOpen: {
    open: false,
  },
  stepDeleteModal: {
    open: false,
  },
  fieldDeleteModal: {
    open: false,
  },
  confirmModal: {
    open: false,
  },
  historyModal: {
    open: false,
  },
  assessmentToolModal: {
    open: false,
    fieldId: null,
    sectionId: null,
    entryIndex: null,
  },
  bodyMapModal: {
    open: false,
  },
  bodyMapOverviewModal: {
    open: false,
  },
  toolSnapshotModal: {
    open: false,
  },
  versionReviewModal: {
    open: false,
  },
  warningModal: {
    open: false,
  },
  preStatusModal: {
    open: false,
  },
  convertResidentModal: {
    open: false,
  },
  residentStatusModal: {
    open: false,
  },
  residentScheduleModal: {
    open: false,
  },
  residentMedicationModal: {
    open: false,
  },
  residentAppointmentModal: {
    open: false,
  },
  draftConfirmationModal: {
    open: false,
  },
  residentGovernanceModal: {
    open: false,
  },
  bodyMapPreviewModal: {
    open: false,
  },
  toolPreviewModal: {
    open: false,
  },
  observationModal: {
    open: false,
  },
  observationFormModal: {
    open: false,
    observationType: null,
  },
  bodyMapEntryModal: {
    open: false,
    observationType: null,
  },
  preAssessmentDocModal: {
    open: false,
  },
  residentDocumentModal: {
    open: false,
  },
  residentDocumentViewModal: {
    open: false,
  },
  revisionViewModal: {
    open: false,
  },
  publishConfirmationModal: {
    open: false,
  },
  snoozeModal: {
    open: false,
    item: null,
  },
  evidenceModal: {
    open: false,
    evidence_json: null,
  },
  governanceStatusModal: {
    open: false,
    item: null,
  },
  assignModal: {
    open: false,
    item: null,
  },
  evaluationModal: {
    open: false,
    residentId: null,
    carePlanId: null,
    currentTemplate: null,
  },
  carePlanEvaluationModal: {
    open: false,
    type: null, // 'frequency' | 'date' – which input to show
    title: null,
    assessmentTemplateId: null,
    residentCarePlanId: null,
    frequency: null,
    nextEvaluationDate: null,
  },
  carePlanStatusModal: {
    open: false,
    carePlanId: null,
    title: null,
    currentStatus: null, // 'draft' | 'published' | 'disabled'
  },
  completeModal: {
    open: false,
    item: null,
  },
  maintenanceComplianceAddModal: {
    open: false,
    isEditing: false,
    certificateUuid: null,
  },
  maintenanceInvoiceAddModal: {
    open: false,
    requestId: null,
    invoice_details: null,
  },
  policyAcknowledgementReportModal: {
    open: false,
    file_path: null,
    file_version_id: null,
    title: null,
  },
  careRoundReportModal: {
    open: false,
    item: null,
  },
  registerModal: {
    open: false,
    registerKey: null,
    residentId: null,
  },
  workspaceModal: {
    open: false,
    view: null,
    residentId: null,
  },
};

const ModalReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TOGGLE_FOLDER_ADD_MODAL:
        draft.isFolderAddModalOpen = action.payload;
        break;
      case TOGGLE_FILE_INFO_MODAL:
        draft.isFileInfoModalOpen = action.payload;
        break;
      case TOGGLE_FOLDER_UPLOAD_MODAL:
        draft.isUploadModalOpen = action.payload;
        break;
      case TOGGLE_DELETE:
        draft.isDeleteModalOpen = action.payload;
        break;
      case TOGGLE_FILE_VALID_MODAL:
        draft.isFileValidationModalOpen = action.payload;
        break;
      case TOGGLE_STEP_DELETE:
        draft.stepDeleteModal = action.payload;
        break;
      case TOGGLE_FIELD_DELETE:
        draft.fieldDeleteModal = action.payload;
        break;
      case TOGGLE_CONFIRM_MODAL:
        draft.confirmModal = action.payload;
        break;
      case TOGGLE_HISTORY_MODAL:
        draft.historyModal = action.payload;
        break;
      case TOGGLE_ASSESSMENT_TOOL_MODAL:
        draft.assessmentToolModal = action.payload;
        break;
      case TOGGLE_BODY_MAP_MODAL:
        draft.bodyMapModal = action.payload;
        break;
      case TOGGLE_BODY_MAP_OVERVIEW_MODAL:
        draft.bodyMapOverviewModal = action.payload;
        break;
      case TOGGLE_TOOLSNAPSHOT_MODAL:
        draft.toolSnapshotModal = action.payload;
        break;
      case TOGGLE_VERSION_REVIEW_MODAL:
        draft.versionReviewModal = action.payload;
        break;
      case TOGGLE_WARNING_MODAL:
        draft.warningModal = action.payload;
        break;
      case TOGGLE_PRE_STATUS_MODAL:
        draft.preStatusModal = action.payload;
        break;
      case TOGGLE_CONVERT_RESIDENT_MODAL:
        draft.convertResidentModal = action.payload;
        break;
      case TOGGLE_RESIDENT_STATUS_MODAL:
        draft.residentStatusModal = action.payload;
        break;
      case TOGGLE_RESIDENT_SCHEDULE_MODAL:
        draft.residentScheduleModal = action.payload;
        break;
      case TOGGLE_RESIDENT_MEDICATION_MODAL:
        draft.residentMedicationModal = action.payload;
        break;
      case TOGGLE_DRAFT_CONFIRMATION_MODAL:
        draft.draftConfirmationModal = action.payload;
        break;
      case TOGGLE_RESIDENT_APPOINTMENT_MODAL:
        draft.residentAppointmentModal = action.payload;
        break;
      case TOGGLE_RESIDENT_GOVERNANCE_MODAL:
        draft.residentGovernanceModal = action.payload;
        break;
      case TOGGLE_BODY_MAP_PREVIEW_MODAL:
        draft.bodyMapPreviewModal = action.payload;
        break;
      case TOGGLE_TOOL_PREVIEW_MODAL:
        draft.toolPreviewModal = action.payload;
        break;
      case TOGGLE_OBSERVATION_MODAL:
        draft.observationModal = action.payload;
        break;
      case TOGGLE_OBSERVATION_FORM_MODAL:
        draft.observationFormModal = action.payload;
        break;
      case TOGGLE_BODY_MAP_ENTRY_MODAL:
        draft.bodyMapEntryModal = action.payload;
        break;

      case TOGGLE_PRE_ASSESSMENT_DOC_MODAL:
        draft.preAssessmentDocModal = action.payload;
        break;
      case TOGGLE_RESIDENT_DOCUMENT_MODAL:
        draft.residentDocumentModal = action.payload;
        break;
      case TOGGLE_RESIDENT_DOCUMENT_VIEW_MODAL:
        draft.residentDocumentViewModal = action.payload;
        break;
      case TOGGLE_REVISION_VIEW_MODAL:
        draft.revisionViewModal = action.payload;
        break;
      case TOGGLE_PUBLISH_CONFIRMATION_MODAL:
        draft.publishConfirmationModal = action.payload;
        break;
      case TOGGLE_SNOOZE_MODAL:
        draft.snoozeModal = action.payload;
        break;
      case TOGGLE_EVIDENCE_MODAL:
        draft.evidenceModal = action.payload;
        break;
      case TOGGLE_GOVERNANCE_STATUS_MODAL:
        draft.governanceStatusModal = action.payload;
        break;
      case TOGGLE_ASSIGN_MODAL:
        draft.assignModal = action.payload;
        break;
      case TOGGLE_EVALUATION_MODAL:
        draft.evaluationModal = action.payload;
        break;
      case TOGGLE_CARE_PLAN_EVALUATION_MODAL:
        draft.carePlanEvaluationModal = action.payload;
        break;
      case TOGGLE_CARE_PLAN_STATUS_MODAL:
        draft.carePlanStatusModal = action.payload;
        break;
      case TOGGLE_COMPLETE_MODAL:
        draft.completeModal = action.payload;
        break;
      case TOGGLE_MONITOR_MODAL:
        draft.monitorModal = action.payload;
        break;
      case TOGGLE_MAINTENANCE_COMPLIANCE_ADD_MODAL:
        draft.maintenanceComplianceAddModal = {
          open: false,
          isEditing: false,
          certificateUuid: null,
          ...action.payload,
        };
        break;
      case TOGGLE_MAINTENANCE_INVOICE_ADD_MODAL:
        draft.maintenanceInvoiceAddModal = {
          open: false,
          requestId: null,
          invoice_details: null,
          ...action.payload,
        };
        break;
      case TOGGLE_POLICY_ACKNOWLEDGEMENT_REPORT_MODAL:
        draft.policyAcknowledgementReportModal = {
          open: false,
          file_path: null,
          file_version_id: null,
          title: null,
          ...action.payload,
        };
        break;
      case TOGGLE_CARE_ROUND_REPORT_MODAL:
        draft.careRoundReportModal = {
          open: false,
          item: null,
          ...action.payload,
        };
        break;
      case TOGGLE_REGISTER_MODAL:
        draft.registerModal = {
          open: false,
          registerKey: null,
          residentId: null,
          ...action.payload,
        };
        break;
      case TOGGLE_WORKSPACE_MODAL:
        draft.workspaceModal = {
          open: false,
          view: null,
          residentId: null,
          ...action.payload,
        };
        break;
      default:
        return state;
    }
  });

export default ModalReducer;
